export default __webpack_public_path__ + "static/media/demolition.97996589.png";